import AiDocumentDetailsContainer from './AiDocumentChunkTable'

export default AiDocumentDetailsContainer
